import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const tantrum2YearOld: BlogMetaData = {
  title: '2歳の癇癪がひどい…原因別の対応と相談の目安｜モンテッソーリ流',
  description:
    '2歳の癇癪はなぜ起きる？自我の育ちと言葉のギャップという発達背景、場面別の対応、避けたいNG対応、落ち着いた後の関わり方、医療・専門機関へ相談する目安までモンテッソーリの視点で解説します。',
  thumbnailUrl: '/img/blog-tantrum-2-year-old.webp',
  filePath: buildBlogFilePath('tantrum-2-year-old'),
  category: BLOG_CATEGORY.PARENTING,
};
